// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Use the node platform by default. The "browser" field of package.json is used
// to override this file to use `./browser/index.ts` when packaged with
// webpack, Rollup, etc.
export * from "./nodejs/index.js";
